var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-bold mt-6",domProps:{"textContent":_vm._s(_vm.item.title)}})}
var staticRenderFns = []

export { render, staticRenderFns }